import mapFunction from './mapResources';

export default mapFunction('material', {
    isFetching: false,
    items: [] 
});
